import { SortDirection } from '@busybusy/webapp-react-ui';
import { isNil } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { sortByCustomField, sortByField } from 'utils/tableUtils';

export default function useTableSorting<T>(
  data: T[],
  defaultSortBy?: keyof T,
  defaultSortDir?: SortDirection,
  getCustomSortField?: (item: T, key: keyof T) => any
) {
  const [sortDirection, setSortDirection] = useState<SortDirection | undefined>(defaultSortDir);
  const [sortedBy, setSortedBy] = useState<keyof T | undefined>(defaultSortBy);
  const [sorted, setSorted] = useState<T[]>(data);
  const [sortIsDirty, setSortIsDirty] = useState(false);

  useEffect(() => {
    if (sortedBy && sortDirection) {
      if (isNil(getCustomSortField)) {
        setSorted(sortByField(sorted, sortedBy, sortDirection));
      } else {
        setSorted(sortByCustomField(sorted, sortedBy, sortDirection, getCustomSortField));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortedBy, sortDirection]);

  useEffect(() => {
    if (sortedBy && sortDirection) {
      if (isNil(getCustomSortField)) {
        setSorted(sortByField(data, sortedBy, sortDirection));
      } else {
        setSorted(sortByCustomField(data, sortedBy, sortDirection, getCustomSortField));
      }
    } else {
      setSorted(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const onSort = useCallback(({ sortDir, sortBy }: any) => {
    setSortedBy(sortBy);
    setSortDirection(sortDir);
    setSortIsDirty(true);
  }, []);

  return {
    sorted: useMemo(() => sorted, [sorted]),
    sortDirection,
    sortedBy,
    onSort,
    sortIsDirty,
  };
}
